import React, { useEffect, useState, useRef } from 'react';
import {
  Typography,
  CircularProgress,
  Box,
  Paper
} from '@mui/material';

import EmpleadoCard from './EmpleadoCard';
import VentasTable from './VentasTable';
import './InfoEmpleado.css';
import TablaHorario from './TablaHorario';

function InfoEmpleado({ id_empleado }) {
  const [horarioData, setHorarioData] = useState(null);
  const [loadingHorario, setLoadingHorario] = useState(true);
  const [empleado, setEmpleado] = useState(null);
  const [loadingEmpleado, setLoadingEmpleado] = useState(true);
  const cardRef = useRef(null);

  useEffect(() => {
    if (!id_empleado) return;

    setLoadingEmpleado(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/empleados/${id_empleado}`)
      .then(res => res.json())
      .then(data => {
        setEmpleado(data);
        setLoadingEmpleado(false);
      })
      .catch(err => {
        console.error('Error al obtener empleado:', err);
        setLoadingEmpleado(false);
      });
  }, [id_empleado]);

  useEffect(() => {
    if (!id_empleado) return;

    setLoadingHorario(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/empleados/horarios/${id_empleado}`)
      .then(res => res.json())
      .then(data => {
        setHorarioData(data);
        setLoadingHorario(false);
      })
      .catch(err => {
        console.error('Error al obtener horario:', err);
        setLoadingHorario(false);
      });
  }, [id_empleado]);

  if (loadingEmpleado) return <CircularProgress />;
  if (!empleado) return <Typography variant="body1">Empleado no encontrado</Typography>;

  return (
    <Box
      sx={{
        height: 'calc(100vh - 100px)', // Ajusta según tu layout general
        boxSizing: 'border-box',
        overflowY: 'auto', // Scroll si no cabe todo
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Fila con EmpleadoCard y Horario */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexShrink: 0,
          minHeight: 200,
          // Ocupa el ancho completo, altura según contenido
        }}
      >
        {/* EmpleadoCard */}
        <Box sx={{ flex: '0 0 300px' }}>
          <EmpleadoCard empleado={empleado} cardRef={cardRef} />
        </Box>

        {/* Horario */}
        <Paper
          elevation={3}
          sx={{
            flex: 1,
            padding: 2,
            backgroundColor: '#f5f5f5',
            overflowY: 'auto',
            minHeight: 200,
          }}
        >
          {loadingHorario ? (
            <CircularProgress />
          ) : horarioData ? (
            <TablaHorario horarioData={horarioData} />
          ) : (
            <Typography variant="body2">No se pudo cargar el horario.</Typography>
          )}
        </Paper>
      </Box>

      {/* Ventas debajo, altura fija 50vh */}
      <Paper
        elevation={3}
        sx={{
          height: '50vh',
          padding: 2,
          backgroundColor: '#e3f2fd',
          overflowY: 'auto',
          flexShrink: 0,
        }}
      >
        <VentasTable id_empleado={id_empleado} />
      </Paper>
    </Box>
  );
}

export default InfoEmpleado;
